const config = {
  AIBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:eccG_gFf:v3.7/",
  GeneralBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:lVDXn798:v3.7/",
  DialogBackendUrl: "https://x7xh-egts-drcc.n2.xano.io/api:7Yj07WtA:v3.7/",
  DataSource: "test",
  ForgotPasswordUrl:
    "https://editor.weweb.io/a5bcfded-f6bc-49c0-9acf-7edf75e31500/b6ca452a-1c02-4f08-862d-62b443e5884b",
};

export default config;
